import { Checkbox, Form, Select, Tabs } from 'antd';
import { TitlesTypes } from '../../../constants/constants';
import { numberedTitleLevels } from '../../../utils/titles';
// import {
//   selectorMaxWidth,
//   selectorMinWidth,
// } from '../../../constants/gridConfig';
import { useStore } from '../../../store/store';
import TitleConfiguration from '../../common/TitleConfiguration';

const selector = ({
  configuration,
  setConfiguration,
  summaryConfiguration,
  setSummaryConfiguration,
  paysageMode,
  setPaysageMode,
  currentTemplate,
}) => ({
  configuration,
  setConfiguration,
  summaryConfiguration,
  setSummaryConfiguration,
  paysageMode,
  setPaysageMode,
  currentTemplate,
});

export const TabsTitles = () => {
  const {
    configuration,
    setConfiguration,
    summaryConfiguration,
    setSummaryConfiguration,
  } = useStore(selector);
  const numberedLevels = numberedTitleLevels(configuration);

  const styleRuleChangeObject = (options = {}) => {
    return {
      setFunction: options.summary ? setSummaryConfiguration : setConfiguration,
      configObject: options.summary ? summaryConfiguration : configuration,
    };
  };

  const handleSelectStyle =
    (type, options = {}) =>
      (e) => {
        const change = styleRuleChangeObject(options);
        const current = change.configObject[type].fontStyle;
        const checked = e?.target?.checked ?? (current === '');
        change.setFunction({
          [type]: {
            ...change.configObject[type],
            fontStyle: checked ? 'italic' : '',
          },
        });
      };

  const handleSelectColor =
    (type, options = {}) =>
      (selectedColor) => {
        const change = styleRuleChangeObject(options);
        change.setFunction({
          [type]: {
            ...change.configObject[type],
            color: configuration.colors.find(
              (color) => color.label === selectedColor
            ),
          },
        });
      };

  const handleSelectWeight =
    (type, options = {}) =>
      (e) => {
        const change = styleRuleChangeObject(options);
        const current = change.configObject[type].fontWeight;
        const checked = e?.target?.checked ?? (current === '');
        change.setFunction({
          [type]: {
            ...change.configObject[type],
            fontWeight: checked ? 'bold' : '',
          },
        });
      };

  const handleSelectDecoration =
    (type, options = {}) =>
      (e) => {
        const change = styleRuleChangeObject(options);
        const current = change.configObject[type].textDecoration;
        const checked = e?.target?.checked ?? (current === '');
        change.setFunction({
          [type]: {
            ...change.configObject[type],
            textDecoration: checked ? 'underline' : '',
          },
        });
      };

  const handleChangeFontSize =
    (type, options = {}) =>
      (value) => {
        const change = styleRuleChangeObject(options);
        change.setFunction({
          [type]: { ...change.configObject[type], fontSize: value },
        });
      };

  const handleChangeBackgroundColor = (type) => (selectedColor) => {
    setConfiguration({
      [type]: {
        ...configuration[type],
        backgroundColor: configuration.colors.find(
          (color) => color.label === selectedColor
        ),
      },
    });
  };

  const handleChangeBorderColor = (type) => (selectedColor) => {
    setConfiguration({
      [type]: {
        ...configuration[type],
        borders: {
          ...configuration[type].borders,
          color: configuration.colors.find(
            (color) => color.label === selectedColor
          ),
        },
      },
    });
  };

  const handleChangeBorderPlace = (type, place) => (e) => {
    if (place !== 'all') {
      setConfiguration({
        [type]: {
          ...configuration[type],
          borders: {
            ...configuration[type].borders,
            [place]: !configuration[type].borders[place],
          },
        },
      });
    } else {
      if (
        configuration[type].borders.top === true &&
        configuration[type].borders.bottom === true &&
        configuration[type].borders.left === true &&
        configuration[type].borders.right === true
      ) {
        setConfiguration({
          [type]: {
            ...configuration[type],
            borders: {
              ...configuration[type].borders,
              top: false,
              bottom: false,
              left: false,
              right: false,
            },
          },
        });
      } else {
        setConfiguration({
          [type]: {
            ...configuration[type],
            borders: {
              ...configuration[type].borders,
              top: true,
              bottom: true,
              left: true,
              right: true,
            },
          },
        });
      }
    }
  };

  const handleChangeTypeTitle = (type) => (e) => {
    setConfiguration({
      [type]: { ...configuration[type], typeTitle: e },
    });
  };

  const handleChangeMarginTop = (type) => (e) => {
    setConfiguration({
      [type]: { ...configuration[type], marginTop: e },
    });
  };

  const handleChangeMarginBottom = (type) => (e) => {
    setConfiguration({
      [type]: { ...configuration[type], marginBottom: e },
    });
  };

  const handleChangeAlignment = (type) => (value) => {
    setConfiguration({
      [type]: { ...configuration[type], textAlign: value },
    });
  };

  const handleChangeVerticalAlignment = (type) => (value) => {
    setConfiguration({
      [type]: { ...configuration[type], verticalAlignment: value },
    });
  };

  const handleChangeTextOffset = (type) => (value) => {
    setConfiguration({
      // InputNumber renvoie null quand on vide le champ.
      [type]: { ...configuration[type], textOffset: value ?? 0 },
    });
  };

  const handleChangeIndexStyle = (type) => (patch) => {
    setConfiguration({
      [type]: {
        ...configuration[type],
        indexStyle: { ...configuration[type].indexStyle, ...patch },
      },
    });
  };

  const handleChangeTextEffect = (type) => (patch) => {
    setConfiguration({
      [type]: {
        ...configuration[type],
        textEffect: { ...configuration[type].textEffect, ...patch },
      },
    });
  };

  const handleChangeSeparatorTitle = (value) => {
    setConfiguration({
      ...configuration,
      separatorTitle: value,
    });
  };

  return (
    <div>
      {/* Pas de `name` : comme l'ancienne case à cocher, le champ est piloté par
          le store et non par l'état du Form, sinon un `initialValue` figé au
          montage afficherait une valeur périmée après rechargement du document. */}
      {/* Une case par niveau, et non plus « à partir du niveau N » : on peut
          numéroter les niveaux 1, 2 et 4 sans numéroter le 3. Le compteur d'un
          niveau décoché reste dans la chaîne de ses sous-titres (cf.
          displayTitleIndex), sauf s'il précède le premier niveau numéroté. */}
      <Form.Item label="Indexation des titres">
        <Checkbox.Group
          value={numberedLevels
            .map((numbered, level) => (numbered ? level + 1 : null))
            .filter(Boolean)}
          options={numberedLevels.map((_numbered, level) => ({
            label: `Niveau ${level + 1}`,
            value: level + 1,
          }))}
          onChange={(checked) => {
            setConfiguration({
              ...configuration,
              numberedTitleLevels: numberedLevels.map((_numbered, level) =>
                checked.includes(level + 1)
              ),
            });
          }}
        />
      </Form.Item>
      <Form.Item
        label='Choix du séparateur'
        name='separatorTitle'
        initialValue={configuration.separatorTitle}
      >
        <Select
          onChange={handleChangeSeparatorTitle}
          style={{ width: 'auto' }}
          options={[
            { value: '-', label: '-' },
            { value: '.', label: '.' },
            { value: '_', label: '_' },
            { value: '#', label: '#' },
          ]}
        >
        </Select>
      </Form.Item>
      {/* Piloté par le store, comme l'indexation (cf. commentaire plus haut). */}
      <Form.Item
        label='Séparateur final'
        tooltip='Coché : « 1.2. » — décoché : « 1.2 »'
      >
        <Checkbox
          checked={configuration.finalSeparatorTitle !== false}
          onChange={(e) => {
            setConfiguration({
              ...configuration,
              finalSeparatorTitle: e.target.checked,
            });
          }}
        />
      </Form.Item>
      {/* Un onglet par niveau : les quatre cartes empilées obligeaient à
          défiler pour atteindre le niveau voulu. */}
      <Tabs
        items={Object.values(TitlesTypes).map((titleType, index) => ({
          key: titleType,
          label: `Niveau ${index + 1}`,
          children: (
            <TitleConfiguration
              key={`title-${titleType}`}
              level={index + 1}
              title={titleType}
              styleRules={configuration[titleType]}
              colors={configuration.colors}
              onChangeVisibility={null}
              onChangeColor={handleSelectColor(titleType)}
              onChangeFontStyle={handleSelectStyle(titleType)}
              onChangeWeight={handleSelectWeight(titleType)}
              onChangeTextDecoration={handleSelectDecoration(titleType)}
              onChangeFontSize={handleChangeFontSize(titleType)}
              onChangeBackgroundColor={handleChangeBackgroundColor(titleType)}
              onChangeBorderColor={handleChangeBorderColor(titleType)}
              onChangeBorderPlace={handleChangeBorderPlace}
              onChangeAlignment={handleChangeAlignment(titleType)}
              onChangeVerticalAlignment={handleChangeVerticalAlignment(titleType)}
              onChangeTextOffset={handleChangeTextOffset(titleType)}
              onChangeIndexStyle={handleChangeIndexStyle(titleType)}
              onChangeTextEffect={handleChangeTextEffect(titleType)}
              onChangeType={handleChangeTypeTitle(titleType)}
              onChangeMarginTop={handleChangeMarginTop(titleType)}
              onChangeMarginBottom={handleChangeMarginBottom(titleType)}
              configuration={configuration}
              titleType={titleType}
              type='title'
            />
          ),
        }))}
      />
    </div >
  );
};
